import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { User } from "../../_models/user";
import { Router, ActivatedRoute } from "@angular/router";
import { Globals } from "../../_models/globals";
import { AlertService } from '../../_services/alert.service';
import * as moment from 'moment';
import { ApiIntegration } from '../../_services/api.integration';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-store-hippo-create',
  templateUrl: './store-hippo-create.component.html',
  styleUrls: ['./store-hippo-create.component.scss'],
})
export class StoreHippoCreateComponent implements OnInit {
  productImage: string = "/assets/images/default-product.png";
  statusText22: string;
  channelName: string;
  statusText11: string;
  token: string;
  instructions: string = 'N';
  imageUrl: string;
  errorMessage: string;
  uploadImage: string;
  scheduleStatusNoError: string = '';

  constructor(private alertService: AlertService, private api: ApiIntegration, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute, public g: Globals) {

  }

  ngOnInit() {

  }

  typeApiKey() {
    this.statusText11 = "";
    if (this.token == '' || this.token === null || this.token === undefined || this.token === 'undefined') {
      this.statusText11 = 'Please enter token';
    }
  }

  submit() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/toStoreMagentoCredentials', {
      "accountOwnerId": this.user.accountOwnerId,
      "refreshToken": this.token,
      "connectionName": this.channelName,
      "organizationId": 1,
      "storeType": "STORE_HIPPO",
      "brandImageUrl": this.imageUrl
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Store Hippo', 'Created Successfully');
          this.router.navigate(['/admin/storeIntegrations']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  showInstructions() {
    this.instructions = 'Y';
  }

  verify() {
    this.g.loaderDisplay = "display";
    this.statusText11 = "";
    this.statusText22 = "";
    this.statusText22 = '';
    if (this.channelName == '' || this.channelName === null || this.channelName === undefined || this.channelName === 'undefined') {
      this.statusText22 = 'Please enter Channel Name';
    }
    if (this.token == '' || this.token === null || this.token === undefined || this.token === 'undefined') {
      this.statusText11 = 'Please enter token';
    }
    if (this.statusText22 != "" || this.statusText11 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/verifyStoreHippoConnection', {
      "accessKey": this.token
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Store Hippo', 'Verified Successfully');
          this.submit();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  typechannelName() {
    this.statusText22 = "";
    if (this.channelName == '' || this.channelName === null || this.channelName === undefined || this.channelName === 'undefined') {
      this.statusText22 = 'Please enter Channel Name';
    }
  }

  loadImage(event) {
    this.productImage = URL.createObjectURL(event.target.files[0]);
    this.uploadImage = event.target.files[0];
    this.errorMessage = "";
    this.submitImage();
  }

  ignoreImage() {
    this.productImage = "/assets/images/default-product.png";
    this.uploadImage = null;
    this.imageUrl = null;
    this.errorMessage = "";
  }


  submitImage() {
    this.g.loaderDisplay = "display";
    const file = this.uploadImage;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    //headerObj = headerObj.append('content-Type', 'multipart/form-data');
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadImageToS3', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.imageUrl = data['message'];
      } else {
        this.imageUrl = "";
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.errorMessage = "Upload Image Failed Please Re-try";
      });
  }


}
